import request from '@/utils/request';

/**
 * 客服中心 - 冻结卡
 * @param {*} data
 * @returns
 */
export function cardFreeze(data) {
  return request({
    url: '/orders/card-info/freeze',
    method: 'post',
    data: data
  });
}

/**
 * 客服中心 - 解冻卡
 * @param {*} data
 * @returns
 */
export function cardThaw(data) {
  return request({
    url: '/orders/card-info/thaw',
    method: 'post',
    data: data
  });
}

/**
 * 客服工作台 - 获取卡信息列表
 * @param {*} params
 * @returns
 */
export function getCardInfoList(params) {
  return request({
    url: '/orders/card-info/list',
    method: 'get',
    params: params
  });
}

/**
 * 客服工作台 - 获取变更明细列表
 * @param {*} params
 * @returns
 */
export function getRecordList(params) {
  return request({
    url: '/orders/record/list',
    method: 'get',
    params: params
  });
}

/**
 * 客服工作台 - 卡信息 - 解锁
 * @param {*} params
 * @returns
 */
export function unlock(params) {
  return request({
    url: '/orders/card-info/unlock',
    method: 'get',
    params: params
  });
}

/**
 * 客服工作台 - 卡信息 - 发送账号密码
 * @param {*} params
 * @returns
 */
export function sendInfo(params) {
  return request({
    url: '/orders/card-info/send-workuser-info',
    method: 'get',
    params: params
  });
}
/**
 * 客服工作台 - 卡信息 - 绑卡
 * @param {*} params
 * @returns
 */
export function bindCard(params) {
  return request({
    url: '/orders/card-info/bind-card',
    method: 'get',
    params: params
  });
}
/**
 * 客服工作台 - 卡信息 - 修改手机号
 * @param {*} params
 * @returns
 */
export function changeMobile(params) {
  return request({
    url: '/orders/card-info/change-mobile',
    method: 'get',
    params: params
  });
}
/**
 * 客服工作台 - 卡信息 - 获取企业账号
 * @param {*} params
 * @returns
 */
export function getAccountList(params) {
  return request({
    url: '/orders/card-info/get-account-list',
    method: 'get',
    hideLoading: true,
    params: params
  });
}
/**
 * 客服工作台 - 卡信息 - 修改主账号
 * @param {*} params
 * @returns
 */
export function changeAccount(params) {
  return request({
    url: '/orders/card-info/change-main-account',
    method: 'get',
    params: params
  });
}
/**
 * 客服工作台 - 卡信息 - 解绑
 * @param {*} params
 * @returns
 */
export function unbindCard(params) {
  return request({
    url: '/orders/card-info/unbind-card',
    method: 'get',
    params: params
  });
}
// 查看卡信息
export function cardInfoView(params) {
  return request({
    url: '/orders/card-info/view',
    method: 'get',
    params: params
  });
}
// 查看卡密码
export function viewPassword(params) {
  return request({
    url: '/orders/card-info/password',
    method: 'get',
    params: params
  });
}

/**
 * 卡操作 - 导出
 * @param {*} data
 * @returns
 */
export function exportExcel(params) {
  return request({
    url: '/cardmake/card-batch/export',
    method: 'get',
    params: params
  });
}
// 卡操作列表
export function cardOperationList(params) {
  return request({
    url: '/cardmake/card-batch/list',
    method: 'get',
    params: params
  });
}
// 卡操作审核
export function cardOperationAudit(params) {
  return request({
    url: '/cardmake/card-batch/audit',
    method: 'get',
    params: params
  });
}
// 批量修改卡类型
export function editBatchCardType(data) {
  return request({
    url: '/cardmake/card-batch/change-cardbin',
    method: 'post',
    data: data
  });
}

/**
 * 卡操作 - 冻结
 * @param {*} data
 * @returns
 */
export function cardOperateFreeze(data) {
  return request({
    url: '/cardmake/card-batch/freeze',
    method: 'post',
    data: data
  });
}

/**
 * 卡操作 - 解冻
 * @param {*} data
 * @returns
 */
export function cardOperateThaw(data) {
  return request({
    url: '/cardmake/card-batch/thaw',
    method: 'post',
    data: data
  });
}
/**
 * 卡操作 - 充值
 * @param {*} data
 * @returns
 */
export function cardRecharge(data) {
  return request({
    url: '/cardmake/card-batch/batch-recharge',
    method: 'post',
    data: data
  });
}

/**
 * 卡操作 - 扣费
 * @param {*} data
 * @returns
 */
export function cardDeduct(data) {
  return request({
    url: '/cardmake/card-batch/batch-point-off',
    method: 'post',
    data: data
  });
}

/**
 * 卡操作 - 扣点原因标签
 * @returns
 */
export function getCardDeductTags(params) {
  return request({
    url: '/cardmake/card-batch/tags',
    method: 'get',
    params: params
  });
}

/**
 * 卡操作 - 延期
 * @param {*} data
 * @returns
 */
export function cardOperateDelay(data) {
  return request({
    url: '/cardmake/card-batch/delay',
    method: 'post',
    data: data
  });
}

/**
 * 迁移卡列表
 * @param {*} data
 * @returns
 */
export function getCardMigrateList(data) {
  return request({
    url: '/orders/card-migrate/list',
    method: 'post',
    data: data
  });
}
/**
 * 迁移卡类型列表菜单
 * @param {*} data
 * @returns
 */
export function getCardTypeList(data) {
  return request({
    url: '/orders/card-migrate/card-type',
    method: 'post',
    data: data
  });
}
/**
 * 迁移卡查看卡密码
 * @param {*} data
 * @returns
 */
export function getCardPwd(data) {
  return request({
    url: '/orders/card-migrate/get-card-pwd',
    method: 'post',
    data: data
  });
}
/**
 * 客服工作台 - 查看二级菜单
 * @param {*} params
 * @returns
 */
export function getChildMenu(params) {
  return request({
    url: '/orders/card-info/get-child-menu',
    method: 'get',
    params: params
  });
}
/**
 * 客服工作台 - 查看订单列表
 * @param {*} params
 * @returns
 */
export function getUserOrderList(params) {
  return request({
    url: '/orders/card-info/user-order-list',
    method: 'get',
    params: params
  });
}
/**
 * 获取延期卡列表
 * @param {*} data
 * @returns
 */
export function getDelayCardList(data) {
  return request({
    url: '/orders/card-info/card-delay-list',
    method: 'post',
    data: data
  });
}
/**
 * 提交延期卡列表
 * @param {*} data
 * @returns
 */
export function subDelayCard(data) {
  return request({
    url: '/orders/card-info/card-delay',
    method: 'post',
    data: data
  });
}
/**
 * 客服工作台 - 订单列表-详情
 * @param {*} params
 * @returns
 */
export function getUserOrderDetail(params) {
  return request({
    url: '/orders/card-info/order-detail',
    method: 'get',
    params: params
  });
}
/**
 * 客服工作台 - 卡序号列表 - 解锁
 * @param {*} params
 * @returns
 */
export function cardUnlock(params) {
  return request({
    url: '/orders/card-info/unlock-card-number',
    method: 'get',
    params: params
  });
}

/**
 * 客服中心 - 冻结该批卡
 * @param {*} data
 * @returns
 */
export function cardBtachFreeze(data) {
  return request({
    url: '/orders/card-info/freeze-user-card',
    method: 'post',
    data: data
  });
}
/**
 * 客服中心 - 解冻该批卡
 * @param {*} data
 * @returns
 */
export function cardBtachThaw(data) {
  return request({
    url: '/orders/card-info/thaw-user-card',
    method: 'post',
    data: data
  });
}

/**
 * 平台客服-高级设置
 * @param {*} data
 * @returns
 */
export function getAdvList(module, params) {
  var url = {
    service_custom: '/kefu/customer-account-new/get-customer-account-extend',
    plat_service_custom: '/plat-service/customer-account/get-customer-account-extend'
  }[module];
  return request({
    url: url,
    method: 'get',
    params: params
  });
}
/**
 * 平台客服-营销参数设置
 * @param {*} data
 * @returns
 */
export function getMarketList(module, params) {
  var url = {
    service_custom: '/kefu/customer-account-new/get-customer-account-marketing',
    plat_service_custom: '/plat-service/customer-account/get-customer-account-marketing'
  }[module];
  return request({
    url: url,
    method: 'get',
    params: params
  });
}
/**
 * 平台客服-营销参数设置获取客户企业影院列表
 * @param {*} data
 * @returns
 */
export function getCinemaList(module, params) {
  var url = {
    service_custom: '/kefu/customer-account-new/get-cinema-list',
    plat_service_custom: '/plat-service/customer-account/get-cinema-list'
  }[module];
  return request({
    url: url,
    method: 'get',
    params: params
  });
}
/**
 * 平台客服-营销参数设置获取客户企业影片列表
 * @param {*} data
 * @returns
 */
export function getMoviesList(module, params) {
  var url = {
    service_custom: '/kefu/customer-account-new/get-movies-list',
    plat_service_custom: '/plat-service/customer-account/get-movies-list'
  }[module];
  return request({
    url: url,
    method: 'get',
    params: params
  });
}
/**
 * 平台客服-不出票手机号黑名单列表
 * @param {*} module
 * @param {*} params
 * @returns
 */
export function getMobileBlackList(module, params) {
  var url = {
    service_custom: '/kefu/customer-account-new/mobile-black-list',
    plat_service_custom: '/plat-service/customer-account/mobile-black-list'
  }[module];
  return request({
    url: url,
    method: 'get',
    params: params
  });
}
/**
 * 平台客服-营获取客户企业个人中心
 * @param {*} data
 * @returns
 */
export function getPersonCenter(module, params) {
  var url = {
    service_custom: '/kefu/customer-account-new/get-customer-account-center',
    plat_service_custom: '/plat-service/customer-account/get-customer-account-center'
  }[module];
  return request({
    url: url,
    method: 'get',
    params: params
  });
}
/**
 * 客服工作台 - 客户配置 - 调价规则
 * @param {*} data
 * @returns
 */
export function getAdjustRule(module, data) {
  var url = {
    service_custom: '/orders/card-info/movie-rules',
    plat_service_custom: '/plat/card-info/movie-rules'
  }[module];
  return request({
    url: url,
    method: 'post',
    data: data
  });
}
/**
 * 客服工作台 - 客户配置 - 调价规则 获取影院信息
 * @param {*} params
 * @returns
 */
export function getAdjustRuleCinema(module, params) {
  var url = {
    service_custom: '/orders/channel-cinema-adjust/rule-cinemas',
    plat_service_custom: '/plat/channel-cinema-adjust/rule-cinemas'
  }[module];
  return request({
    url: url,
    method: 'post',
    params: params
  });
}
/**
 * 客服中心 - 查看密码
 * @param {*} params
 * @returns
 */
export function getOrderCardInfoPwd(params) {
  return request({
    url: '/orders/card-info/password',
    method: 'get',
    params: params
  });
}

// 查看卡序号类型 次卡
export function getGroupCardNumberType(data) {
  return request({
    url: '/cardmake/card-batch/get-groupid-by-card-number',
    method: 'post',
    data: data
  });
}
export function getBindCardLog(data) {
  return request({
    url: '/orders/card-info/bind-card-log',
    method: 'post',
    data: data
  });
}
/**
 * 客服工作台 - 删除恢复用户
 * @param {*} params
 * @returns
 */
export function changeUserStataus(data) {
  return request({
    url: '/orders/card-info/change-user-status',
    method: 'post',
    data: data
  });
}
// 用户信息-高级设置
export function userSet(data) {
  return request({
    url: '/kefuapi/user-risk/channel-save-config',
    method: 'post',
    data: data
  });
}
// 用户信息-获取高级设置
export function getUserSet(params) {
  return request({
    url: '/kefuapi/user-risk/channel-user-config',
    method: 'get',
    params: params
  });
}
// 客服工作台-获取卡包信息
export function getCardListInfo(params) {
  return request({
    url: '/orders/card-info/get-card-list',
    method: 'get',
    params: params
  });
}

// 客服工作台-获取购物车信息
export function getShoppingCar(params) {
  return request({
    url: '/orders/card-info/cart',
    method: 'get',
    params: params
  });
}
// 客服工作台-删除购物车
export function removeShoppingCar(params) {
  return request({
    url: '/orders/card-info/cart-del',
    method: 'get',
    params: params
  });
}
// 客服工作台-购物车-修改数量
export function updateNum(data) {
  return request({
    url: '/orders/card-info/cart-update-num',
    method: 'post',
    data: data
  });
}
// 客服工作台-购物车-商城更新购物车
export function cartShopUpdateNum(params) {
  return request({
    url: '/orders/card-info/cart-shop-update-num',
    method: 'get',
    params: params
  });
}
// 客服工作台-购物车-自足礼包更新购物车
export function cartPackageSelfUpdateNum(params) {
  return request({
    url: '/orders/card-info/cart-package-self-update-num',
    method: 'get',
    params: params
  });
}
// 客服工作台-购物车-自组礼包更新购物车
export function cartPackageUpdateNum(params) {
  return request({
    url: '/orders/card-info/cart-package-update-num',
    method: 'get',
    params: params
  });
}
// 客服工作台-购物车-礼包购物车更新
export function cartPackageBatchUpdateNum(params) {
  return request({
    url: '/orders/card-info/cart-package-batch-update-num',
    method: 'get',
    params: params
  });
}
// 客服工作台-日志
export function getOperationLogList(params) {
  return request({
    url: '/user/operation-log/k-platform',
    method: 'get',
    params: params
  });
}
// 客服工作台-搜索
export function getOperationLogTypes(params) {
  return request({
    url: '/user/operation-log/types',
    method: 'get',
    params: params
  });
}
// 客服中心-日志
export function getOperationLogCenterList(params) {
  return request({
    url: '/user/operation-log/k-center',
    method: 'get',
    params: params
  });
}
// 商城管理用户信息-日志
export function getOperationLogShopList(params) {
  return request({
    url: '/user/operation-log/shop-user',
    method: 'get',
    params: params
  });
}
// 客服工作台-购物车-礼包清单
export function getWorkSalesGiftPackageList(params) {
  return request({
    url: '/package/package/work-bench-package',
    method: 'get',
    timeout: 3 * 60 * 1000,
    params: params
  });
}
// 未绑定的虚拟卡列表
export function getVirtualCardList(params) {
  return request({
    url: '/orders/card-info/get-virtual-card-list',
    method: 'get',
    params: params
  });
}
//
export function getOperationLog(params) {
  return request({
    url: '/user/operation-log/login-log',
    method: 'get',
    params: params
  });
}
// 微信绑定账号数-配置详情
export function getWechatRiskConfig(params) {
  return request({
    url: '/user/wechat-risk/config',
    method: 'get',
    params: params
  });
}
// 微信绑定账号数-保存配置
export function saveWechatRiskConfig(data) {
  return request({
    url: '/user/wechat-risk/save-config',
    method: 'post',
    data: data
  });
}
// 清除用户登录状态
export function clearLoginStatus(params) {
  return request({
    url: '/orders/card-info/sign-out',
    method: 'get',
    params: params
  });
}
// 客服工作台-购物车-tab
export function getCartLists(params) {
  return request({
    url: '/orders/card-info/cart-lists',
    method: 'get',
    params: params
  });
}

// 客服工作台-日志
export function getMockLogList(params) {
  return request({
    url: '/user/user/mock-log',
    method: 'get',
    params: params
  });
}

// 客服工作台-日志
export function getMockLogWith(params) {
  return request({
    url: '/user/user/mock-log-with',
    method: 'get',
    params: params
  });
}

// 获取模拟登录url
export function centerMockLogin(data) {
  return request({
    url: '/user/user/mock-login',
    method: 'post',
    data: data
  });
}

// 设置默认账号
export function setDefaultAccount(data) {
  return request({
    url: '/orders/card-info/set-default-account',
    method: 'post',
    data: data
  });
}
// 设置默认账号
export function clearMallCache(data) {
  return request({
    url: '/orders/card-info/clear-uid-cache',
    method: 'post',
    data: data
  });
}